import { useEffect, useMemo } from 'react';
import { notification } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { RESET_ON_ERROR } from 'redux/auth/actions';

export const ErrorBoundary = () => {
  const error = useSelector((state) => state.auth.errorBoundary);
  const dispatch = useDispatch();
  const memoError = useMemo(() => error, [error]);

  useEffect(() => {
    if (memoError) {
      notification.open({
        message: 'Ошибка:',
        type: 'error',
        description: memoError,
        duration: 10,
        onClose: () => {
          dispatch({ type: RESET_ON_ERROR });
        },
      });
    }
  }, [dispatch, memoError]);
};
